// A company's custom columns (company.permissions.customColumns) on the upload and edit screens.
// In a table row a custom column lives under "custom:<name>"; the API takes and returns them as row.customColumns.
const PREFIX = "custom:";

const DOCUMENTS = "documents";

// documents columns come last: an imported sheet has no cell for them, so they must not shift the others
const columnsOf = (company, platform) => {
  const columns = (company?.permissions?.customColumns || []).filter((column) => column.platforms.includes(platform));
  return [...columns.filter((column) => column.inputType !== DOCUMENTS), ...columns.filter((column) => column.inputType === DOCUMENTS)];
};

// the documents columns of a platform, with their table keys
export const documentsColumns = (company, platform) =>
  columnsOf(company, platform)
    .filter((column) => column.inputType === DOCUMENTS)
    .map((column) => ({ key: PREFIX + column.name, name: column.name, maxFiles: column.maxFiles || 1 }));

// the documents column behind a table key, or undefined
export const documentsColumnOf = (company, platform, key) =>
  columnsOf(company, platform).find((column) => column.inputType === DOCUMENTS && PREFIX + column.name === key);

export const customColumnKeys = (company, platform) =>
  columnsOf(company, platform).map((column) => PREFIX + column.name);

export const isCustomColumnKey = (key) =>
  typeof key === "string" && key.startsWith(PREFIX);

export const customColumnLabel = (key) => key.slice(PREFIX.length);

// API record -> table row
export const flattenCustomColumns = (row) => {
  const flat = { ...row };
  Object.entries(row.customColumns || {}).forEach(([name, value]) => {
    flat[PREFIX + name] = value;
  });
  return flat;
};

// table row -> API record
export const nestCustomColumns = (row) => {
  const record = {};
  const customColumns = {};
  Object.entries(row).forEach(([key, value]) => {
    if (isCustomColumnKey(key)) customColumns[customColumnLabel(key)] = value;
    else record[key] = value;
  });
  return { ...record, customColumns };
};
